<template>
  <BaseItem
      ref="BaseItem"
      :item-uid="itemUid"
      :subtract-height="subtractHeight"
      :parentComponent="parentComponent"
      dto-detail-model="CustomerOrderSoloDetailQueryDTO"
      dto-save-model="CustomerOrderSoloSaveCommandDTO"
      dto_validate_model="CustomerOrderSoloValidateCommandDTO"
      dto-restore-model="CustomerOrderSoloRestoreCommandDTO"
      dto-filter-restore-model="CustomerOrderSoloDetailResponseDTO"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
      @resize="onResize"
      @cancel="$emit('cancel')"
      @save="onSave"
      :readonly="readonly"
      :dialog="dialog"
      :metadata="metadata"
  >
    <template v-slot:body="{editedItem, lockPage, instance, slotHeight, editedItemCommon}">
      <v-row class="mb-3 px-3">
        <v-col cols="4">
          <BaseFieldString v-model="editedItem.title" :label="$t('title')" readonly="">
            <template v-slot:prepend>
              <BaseNotionLink :value="editedItem.notion_id"></BaseNotionLink>
            </template>
          </BaseFieldString>
        </v-col>
        <v-col cols="2">
          <BaseFieldDate v-model="editedItem.date_receipt" :label="$t('date_receipt')" readonly=""></BaseFieldDate>
        </v-col>
        <v-col cols="3">
          <BaseFieldString v-model="editedItem.status" :label="$t('status')" readonly=""></BaseFieldString>
        </v-col>
        <v-col cols="1">
          <BaseFieldNumber v-model="editedItem.lot_size" :label="$t('lot_size')" readonly=""></BaseFieldNumber>
        </v-col>
        <v-col cols="1">
          <BaseFieldNumber v-model="editedItem.smd" :label="$t('smd')" readonly=""></BaseFieldNumber>
        </v-col>
        <v-col cols="1">
          <BaseFieldNumber v-model="editedItem.tht" :label="$t('thd')" readonly=""></BaseFieldNumber>
        </v-col>
      </v-row>
      <BaseDetailTableFiltered
          ref="refBaseDetailFilteredTableImport"
          :item-list.sync="editedItem.batchruns"
          :height="componentHeight - 290"
          :height-toolbar="48"
          :dialog-width="windowWidth * 0.9"
          :columns="columnsBatchRun"
          edit-component-path="/PBatchRun/BatchRun/PBatchRunEditDialog"
          :left-cols="12"
          :show-select="false"
          :single-select="false"
          :edited-item="editedItem"
          :fetch-action="instance.fetchAction"
          row-statuses="row_status_import"
          row-filter-names="row_filters"
          :bar-statuses.sync="instance.editedItemCommon.bar_statuses_import"
          :bar-filters.sync="instance.editedItemCommon.bar_filters_import"
          :show-expand="false"
          :single-expand="false"
          item-key="uid"
      >
        <template v-slot:top.bar.search="params">
          {{ '' }}
        </template>
        <template v-slot:top.bar.action.middle="params">
          <BaseBtnActionGroup
              :bar-action-group="instance.editedItemCommon.bar_actions"
              :fetch-action="instance.fetchAction"
              :edited-item="editedItem"
              :selected-items="params.selectedItems"
              :loading="instance.commandLoading"
          >
          </BaseBtnActionGroup>
        </template>
        <template v-slot:top.bar.overlay="params">
          <v-overlay :value="instance.commandLoading">
            <v-progress-circular
                indeterminate
                size="32"
            ></v-progress-circular>
          </v-overlay>
        </template>
        <template v-slot:item.status="{ item }">
          <v-icon v-if="item.status === 'reliable'" small color="success" class="mt-0">
            mdi-check-circle-outline
          </v-icon>
          <v-icon v-if="item.status === 'no_full_match'" small color="warning" class="mt-0">
            mdi-alert-circle-check-outline
          </v-icon>
          <v-icon v-if="item.status === 'unreliable'" small color="error" class="mt-0">
            mdi-alert-circle-outline
          </v-icon>
        </template>
      </BaseDetailTableFiltered>
    </template>
  </BaseItem>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';
// import {mapFields} from 'vuex-map-fields';
import {v4 as uuidv4} from "uuid";
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseDetailTable from "@/components/Base/BaseDetailTable";
// import BaseItemProperty from "@/components/Base/BaseItemProperty";
import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import BaseTable from "@/components/Base/BaseTable";
import BaseImageCard from "@/components/Base/BaseImageCard";
// import BomTable from "@/components/Component/Bom/BomTable";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldText from "@/components/Base/BaseFieldText";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldLink from "@/components/Base/BaseFieldLink";
import BaseSelectFromTable from "@/components/Base/BaseSelectFromTable";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import BaseDialogSelectFromTable from "@/components/Base/BaseDialogSelectFromTable";
// import CasePackageSupplyDefault from "@/components/Component/CasePackage/CasePackageSupplyDefault";
import BaseStatusIcon from "@/components/Base/BaseStatusIcon";
import BaseFieldDate from "@/components/Base/BaseFieldDate";
import BaseDetailTableFiltered from "@/components/Base/BaseDetailTableFiltered";
import BaseBtnActionGroup from "@/components/Base/BaseBtnActionGroup";
import BaseNotionLink from "@/components/Base/BaseNotionLink";

export default {
  name: 'PCustomerOrderSoloItem',
  props: {
    subtractHeight: {type: [Number], default: 240},
    height: {type: [Number], default: window.innerHeight},
    itemUid: {default: null},
    store_name: {type: [String], default: 'PBatchRunTaskTable'},
    parentComponent: {type: [String], default: 'PBatchRunTaskTable'},
    modalDialog: {type: [Boolean], default: false},
    dialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    readonly: {type: [Boolean], default: false},
    metadata: {default: null},
    showBom: {default: true},
  },

  components: {
    BaseFieldDate,
    BaseFieldString,
    ConfirmDialog,
    BaseItem,
    BaseDetailTable,
    BaseTable,
    BaseImageCard,
    // BomTable,
    BaseFieldText,
    BaseFieldNumber,
    BaseFieldLink,
    BaseSelectFromTable,
    BaseFieldSelect,
    BaseFieldCheck,
    BaseDialogSelectFromTable,
    // CasePackageSupplyDefault,
    BaseStatusIcon,
    BaseDetailTableFiltered,
    BaseBtnActionGroup,
    BaseNotionLink,
  },

  computed: {},

  methods: {
    onSave(editedItem) {
      // console.log('ComponentOneItem onSave')
      this.$emit('save', editedItem)
      // this.$emit('change-search-term', editedItem.alias)
    },
    onResize(height) {
      // console.log('onResize', height)
      this.windowWidth = window.innerWidth
      this.componentHeight = height
    },
  },

  async mounted() {
  }
  ,

  data() {
    return {
      componentHeight: this.height,
      windowWidth: 900,
      searchBomSheet: null,
      columnsBatchRun: [
        {text: '', value: 'edit', sortable: false, align: 'center', divider: true, width: 10},
        {
          text: 'S',
          value: 'row_status',
          sortable: false,
          align: 'center',
          divider: false,
          width: 20,
          type: 'status'
        },
        {text: 'delivery_date', value: 'delivery_date', sortable: false, align: 'center', divider: true, width: 30},
        {text: 'quantity', value: 'quantity', sortable: false, align: 'center', divider: true, width: 250},
        {
          text: 'customer_order_no',
          value: 'customer_order_no',
          sortable: false,
          align: 'center',
          divider: true,
          width: 50
        },
        {text: 'lot_size_smd', value: 'lot_size_smd', sortable: false, align: 'center', divider: true, width: 20},
        {text: 'lot_size_tht', value: 'lot_size_tht', sortable: false, align: 'center', divider: true, width: 5},
        {text: 'sn_smd', value: 'sn_smd', sortable: false, align: 'center', divider: true, width: 5},
        {text: 'sn_tht', value: 'sn_tht', sortable: false, align: 'center', divider: true, width: 5},
      ],
    }
  }
}
</script>

<style>
</style>

<i18n src="@/components/PBatchRun/locales.json">
</i18n>
